// extracted by mini-css-extract-plugin
export default {"cls1":"EAhHhPQaNw9C4AFzEosr","cls2":"sBsY3cfWhiG5FyI0yvng EAhHhPQaNw9C4AFzEosr"};